
import {
  defineComponent,
  onBeforeUnmount,
  onMounted,
  ref,
  useFetch,
  useMeta,
  computed,
} from '@nuxtjs/composition-api';
import {
  usePage,
  useAlternateLinks,
  useFetchServiceCenters,
  useFetchCities,
  useFetchCountries,
} from '@/composables';

export default defineComponent({
  setup() {
    const { page, fetchPage } = usePage('user-help-desk');
    const { alternateLinks } = useAlternateLinks();
    const { serviceCenters, fetchServiceCenters, centers } =
      useFetchServiceCenters();
    const { fetchCountries, countries } = useFetchCountries();
    const { fetchCities, cities, loading: citiesLoading } = useFetchCities();

    const supportModal = ref(null);
    const serviceModal = ref(null);
    const serviceModalSuccessSentMessage = ref(null);

    const isServiceCentersExist = computed(
      () => countries.value.length > 0 && serviceCenters.value.length > 0,
    );
    useFetch(async () => {
      await fetchPage();
      await fetchCountries();
      await fetchServiceCenters();
    });
    useMeta({
      link: alternateLinks.value,
    });
    const onSuccessServiceForm = () => {
      serviceModal?.value.close();
      serviceModalSuccessSentMessage?.value.open();
    };
    onMounted(() => {
      const chatBotWidgetElement = document.querySelector('#fxo-widget-iframe');
      if (chatBotWidgetElement) chatBotWidgetElement.style.display = 'block';
    });
    onBeforeUnmount(() => {
      FxoMessenger.destroy();
      const chatBotWidgetElement = document.querySelector('#fxo-widget-iframe');
      if (chatBotWidgetElement) chatBotWidgetElement.style.display = 'none';
    });
    return {
      supportModal,
      serviceModal,
      serviceModalSuccessSentMessage,
      serviceCenters,
      countries,
      cities,
      fetchCities,
      onSuccessServiceForm,
      citiesLoading,
      page,
      centers,
      isServiceCentersExist,
    };
  },
  head: {
    script: [
      {
        src: 'https://widget.flowxo.com/embed.js',
        'data-fxo-widget':
          'eyJ0aGVtZSI6IiMwOTI2M2UiLCJ3ZWIiOnsiYm90SWQiOiI2MjM4NmFhNjg0NzJkNTAwMTM1Zjc4YTYiLCJ0aGVtZSI6IiMwOTI2M2UiLCJsYWJlbCI6IlRlY2huaWNhbCBzdXBwb3J0In0sIndlbGNvbWVUZXh0IjoiVGVjaG5pY2FsIHN1cHBvcnQifQ==',
        'data-hide-welcome-message-seconds': '120',
        'data-hide-welcome-message-days': '0',
        'data-reveal-welcome-message-seconds': '1',
        async: true,
        defer: true,
      },
    ],
  },
});
